<template>
  <div id="overlay" v-show="visible">
    <div class="flex w-full">
      <Header :content="contentHeaderFooter" class="header"></Header>
    </div>
    <div id="content">
      <div v-if="errorType === 'outOfStock'" class="max-w-5xl mx-auto w-full">
        <div class="bg-white pt-12 rounded-lg shadow-md sm:p-4">
          <div class="max-w-xl mx-auto">
            <h2 class="heading">ご選択いただいた宿泊プランは売り切れました。</h2>
            <p class="text-base">
              ご希望の日程は、すでに満室のため予約を行うことができません。<br />
              誠に申し訳ございませんが、改めて<a :href="backSearchMenu">検索画面</a>から別の日程・プラン、施設をご検討ください。
              <span class="text-sm block mt-1">
                ※Bene楽天トラベルは、「楽天トラベル」から定期的にデータを取得し、ベネフィット･ステーション上に情報更新をしてご案内しております。<br />
                データ更新の都合上、画面上でプランが表示されていても、予約ができない場合がございます。
              </span>
            </p>
            <div class="mx-auto w-1/2">
              <img src="@/assets/images/sorry.png">
            </div>
          </div>
        </div>
        <div class="flex items-center gap-1 my-8">
          <Icon name="arrow_left" width="24" height="24" color="#da291c" />
          <a class="text-base text-black hover:text-red-600" :href="topDomain">Topに戻る</a>
        </div>
      </div>
      <div v-else class="h-screen flex w-full">
        <div class="vx-col flex items-center justify-center flex-col mx-auto text-center">
          <div class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse font-30">
            {{errorMessage}}
          </div>
          <div class="sm-btn">
            <button @click="handleClose" class="c-btn btn-grey btn-cm">
              {{ finalButtonLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { bus } from '@/main'
export default {
  components: {
    Header,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ""
    },
    errorType: {
      type: String,
      default: ""
    },
    buttonLabel: {
      type: String,
      default: "戻る"
    }
  },
  data() {
    return {
      errors: {
        default: '有効なメニュー・プランがございませんでした。',
        plan: '有効なプランがございませんでした。',
        publicStay: '公共の宿のサービスはご入会頂いているコースに対応しておりません。',
        stock: '指定された日付のプランがございませんでした。',
        appliy: '申込できるメニュープランがありません。'
      },
      contentHeaderFooter: null,
      isPublicMenu:false,
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    bus.$on('noPuclicDate', (val)=>{
      console.log(val)
      this.isPublicMenu = val
    })
  },
  beforeDestroy(){
    bus.$off('noPuclicDate')
  },
  watch: {
  },
  computed: {
    errorMessage() {
      return this.errors[this.errorType] || this.errors.default
    },
    finalButtonLabel() {
      if (this.$router.referrer.path === "/") return "トップへ"
      return this.buttonLabel
    },
    topDomain() {
      return process.env.VUE_APP_TOP_DOMAIN
    },
    backSearchMenu() {
      const baseUrl = '/search/menu';
      const query = this.$router.referrer.query
      const queryString = Object.keys(query)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
        .join('&');
      if(!queryString) return baseUrl
      return `${baseUrl}?${queryString}`;
    }
  },
  methods: {
    handleClose() {
      // 遷移先指定
      if (this.$router.referrer.path === "/") {
        window.location.href = process.env.VUE_APP_TOP_DOMAIN
      } else if (this.url) {
        window.location.href = this.url
      } else {
        this.$router.back()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.font-30 {
  font-size: 30px;
}
.header {
  width: 100%;
}
.l-container {
    @screen sm {
      border-radius: 0;
    }
    padding-left: 50px;
    width: 100%;
    background-color: #ffffff;
}
#overlay{
  z-index:1;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);
  overflow-y: scroll;
}
#content {
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 32px 20px 0;
  background: #e5e5e5;
}
.heading {
  margin-bottom: 48px;
  color: #1F2021;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  position: relative;
  padding-left: 24px;
  @include mq() {
    margin-bottom: 24px;
    font-size: 20px;
  }
  &::before {
    content: '';
    border-left: 4px solid #da291c;
    border-radius: 4px;
    margin-right: 1.5rem;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
}
</style>